import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RadioChoiceModule } from '../../core-ui/RadioChoice/RadioChoice.module';
import { PersonTypeRadioComponent } from './PersonTypeRadio.component';

export const PersonTypeRadioModuleExports = [PersonTypeRadioComponent];

@NgModule({
    imports: [CommonModule, RadioChoiceModule, FormsModule],
    declarations: [...PersonTypeRadioModuleExports],
    exports: [...PersonTypeRadioModuleExports],
    providers: []
})
export class PersonTypeRadioModule {}
